import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { mobile } from '../../styles/media'
import Icon from './Icon'

class OnPageSpinner extends Component {
	static propTypes = {
		delay: PropTypes.bool,
		size: PropTypes.number
	}

	static defaultProps = {
		delay: true,
		size: 30
	}

	state = {
		show: !this.props.delay
	}

	componentDidMount() {
		const { delay } = this.props

		if (delay) {
			this.loadingTimeout = window.setTimeout(() => {
				this.setState({
					show: true
				})
			}, 1000)
		}
	}

	componentWillUnmount() {
		clearTimeout(this.loadingTimeout)
	}

	render() {
		const { size } = this.props
		const { show } = this.state

		return (
			<StyledOnPageSpinner show={show}>
				<Icon spinner name="loading" size={size} />
			</StyledOnPageSpinner>
		)
	}
}

export const StyledOnPageSpinner = styled.div`
	opacity: ${props => props.show ? 1 : 0};
	padding-top: 2rem;
	transition: opacity 0.2s;

	${mobile`
		padding-top: 4rem;
		text-align: center;
	`}
`

export default OnPageSpinner
